import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  img: {
    maxWidth: '100%',
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    textAlign: 'center',
  },
  backButton: {
    width: 'auto',
  },
}));

export default useStyles;
